export default {
	message_compose_placeholder: 'Nachricht schreiben...',
	message_empty_caption: 'Schreibe unten die erste Nachricht',
	message_empty_title: 'Noch keine Nachrichten',
	message_has_multiple_receivers: 'hat mehrere Empfänger',
	message_pick_receivers: 'Empfänger wählen',
	message_receivers: 'Nachrichtenempfänger',
	message_receivers_count: '{count} Empfänger',
	message_receivers_deselect_all: 'Alle abwählen',
	message_receivers_done: 'Fertig',
	message_receivers_group_member_count: '{n} Person | {n} Personen',
	message_receivers_section_groups: 'Gruppen',
	message_receivers_section_people: 'Personen',
	message_receivers_section_selected: 'Ausgewählt',
	message_remove_receiver: '{name} entfernen',
	message_send_and_memorize_label: 'Senden & Merken',
	message_send_label: 'Senden',
	message_show_all_receivers: 'alle Empfänger anzeigen',
	message_time_label: 'Uhr',
};
